(() => {
  const selector = 'shopify-forms-embed#app-embed-container-100759';
  const until = performance.now() + Math.max(0, Number(document.documentElement.dataset.swNewsletterUntil || 0) - Date.now());
  let attempts = 0;
  const install = () => {
    const host = document.querySelector(selector);
    if (!host) return false;
    if (performance.now() < until) host.inert = true;
    if (!host.shadowRoot) return false;
    if (!host.shadowRoot.querySelector('[data-sw-newsletter-style]')) {
      const style = document.createElement('style');
      style.dataset.swNewsletterStyle = '';
      style.textContent = '@media(max-width:768px){#app-embed{--container-max-w:min(397px,calc(100vw - 24px));--forms-padding-top:20px;--forms-padding-bottom:20px;--forms-padding-left:18px;--forms-padding-right:18px;--forms-heading-font-size:20px;--heading-font-size:20px}section[role="dialog"][data-sizing="form-wrapper"]{display:block!important;max-height:calc(100dvh - 48px)!important;overflow-y:auto!important;max-width:calc(100vw - 24px)!important}[style*="background-image"]{height:90px!important;min-height:90px!important;max-height:90px!important}input{font-size:16px!important}[aria-label="Close modal"]{min-width:44px;min-height:44px;display:flex;align-items:center;justify-content:center}}';
      host.shadowRoot.append(style);
    }
    return true;
  };
  const timer = setInterval(() => {
    attempts++;
    if (install() || attempts > 160) clearInterval(timer);
  },250);
  install();
  setTimeout(() => {
    const host = document.querySelector(selector);
    if (host) host.inert = false;
    document.documentElement.classList.remove('sw-newsletter-wait');
  },Math.max(0,until-performance.now()));
})();